import {AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {PortalService} from "../../services/portal.service";
import {PhotovoltaikcheckAnfrage} from "../anfrage/photovoltaikcheck.anfrage";
import {ActivatedRoute, Router} from "@angular/router";
import {PhotovoltaikcheckRequestService} from "../services/request.service";
import {PhotovoltaikcheckBackendService} from "../services/backend.service";
import {PhotovoltaikcheckConstants} from "../photovoltaikcheck.constants";
import {Configuration, Optimierung} from "../interfaces/configuration";
import {Result} from "../interfaces/result";
import {FormControl, FormGroup} from "@angular/forms";
import {Subscription} from "rxjs";
import {DecimalPipe} from "@angular/common";
import {DiaglogData} from "../../interfaces/diaglog.data";
import {PortalTeaserComponent} from "../../teaser/portal.teaser.component";
import {ElementService} from "../../services/element.service";
import {ConfigurationAdaptions} from "../interfaces/configuration-adaptions";

/**
 * Component for the entry of the moderat. Let the user select its interests.
 */
@Component({
  selector: 'app-photovoltaikcheck-ergebnis',
  templateUrl: './ergebnis.component.html',
  providers: [DecimalPipe]
})
export class ErgebnisComponent implements OnInit, OnDestroy, AfterViewInit {

  /**
   * Paths for the back button
   */
  readonly PATH_INPUT_PV: string = '../../eingabe/aufstellort/3';
  readonly PATH_INPUT_BALKON: string = '../../eingabe/aufstellort/2';
  readonly PATH_INPUT_BALKON_FREIFLAECHE: string = '../../eingabe/aufstellort/1';

  /**
   * input in field 'interesse' if in balcony path
   */
  readonly INTERESSE_BALKON: string = PhotovoltaikcheckConstants.PATH_BALKONKRAFTWERK;
  readonly INTERESSE_PV: string = PhotovoltaikcheckConstants.PATH_PVANLAGE;

  /**
   * The available optimizations of the result configurations
   */
  readonly OPTIMIERUNG_WIRTSCHAFTLICH: Optimierung = 'wirtschaftlich';
  readonly OPTIMIERUNG_UNABHAENGIG: Optimierung = 'unabhaengig';
  readonly OPTIMIERUNG_VOLLEINSPEISUNG: Optimierung = 'volleinspeisung';
  readonly OPTIMIERUNG_INDIVIDUELL: Optimierung = 'individuell';
  readonly OPTIMIERUNG_POSTFIX_VOLLEINSPEISUNG: string = PhotovoltaikcheckConstants.OPTIMIERUNG_POSTFIX_VOLLEINSPEISUNG;

  /**
   * wrapper for the configuration selection
   */
  @ViewChild('devices') devices: ElementRef;

  /**
   * wrapper for the economics section
   */
  @ViewChild('invest') invest: ElementRef;

  /**
   * Top element to scroll to
   */
  @ViewChild('top') top: ElementRef;

  /**
   * Backcard of the compare flipper
   */
  @ViewChild('backCardCompare') backCardCompare: ElementRef;

  /**
   * Frontcard of the compare flipper
   */
  @ViewChild('frontCardCompare') frontCardCompare: ElementRef;

  /**
   * Scrolltarget if the result has changed
   */
  @ViewChild('resultScrollTarget') resultScrollTarget: ElementRef;

  /**
   * Focus button in overlay if the credit toggle is activated
   */
  @ViewChild('creditOverlayButton', {static: false}) creditOverlayButton: ElementRef;

  /**
   * min height of the compare element to avoid overlay after flipping
   */
  minHeightCompare: number = null;

  /**
   * Link for the backbutton
   */
  previousLink: string;

  /**
   * the current userdata
   */
  anfrage: PhotovoltaikcheckAnfrage;

  /**
   * Holds the result, as given from the server
   */
  result?: Result = null;

  /**
   * current configuration that we show on the page.
   */
  configuration?: Configuration = null;

  /**
   * plaeholder for the curren selected configuration.
   */
  placeholder?: {[key: string]: string | number};

  /**
   * some ratings for the current configuration
   */
  ratings?: {[key: string]: string | number};

  /**
   * currently selected optimization type
   */
  currentConfigurationType: Optimierung;

  /**
   * List of configurations that are available
   */
  hasFeedinConfiguration: boolean = false;

  /**
   * toggle if the user as used a individual configurations
   */
  hasIndividualConfiguration: boolean = false;

  /**
   * available own-use-configuration on which the user can select
   */
  ownUseConfigurations: Optimierung[] = [];

  /**
   * List of configurations that we want to compare
   */
  compareConfigurations: Optimierung[] = [];

  /**
   * Textkey for all texts on the page.
   */
  textkeyPrefix: string = 'photovoltaikcheck.ergebnis';

  /**
   * Form for the result page
   */
  form: FormGroup = new FormGroup({
    credit: new FormControl(false, []),
    eigenkapital: new FormControl(null, []),
    volleinspeisung: new FormControl(null, []),
  });

  /**
   * list of subscriptions in this component.
   */
  subscriptions: Subscription[] = [];

  /**
   * toggle to show the credit
   */
  hasCredit: boolean = false;

  /**
   * minimum of the slider
   */
  sliderMin: number = 0;

  /**
   * maximum of the slider
   */
  sliderMax: number = 0;

  /**
   * show loading animation
   */
  loading: boolean = false;

  /**
   * url of the report for the download and newsletter
   */
  reportUrl: string;

  /**
   * toggle if internal or external portal
   */
  internalPortal: boolean = false;

  /**
   * show/hide toggle for volleinspiesung
   */
  hasVolleinspeisung: boolean = false;

  /**
   * toggle to force the (newsletter) dialog
   */
  forceDialog: boolean = false;

  /**
   * toggle to show/hide the download element
   */
  showDownload: boolean = false;

  /**
   * holds the id of the html element where to jump to after click on dialog hint
   */
  idTargetElement: string = null;

  /**
   * data that is sent to the backend when the dialog form is submitted
   */
  dialogData: DiaglogData;

  /**
   * toggel to show/hide the portal teaser
   */
  hasPortalTeaser: boolean = false;

  /**
   * topics for the faq, will be received from the backend
   */
  faqTopics: string[] = [];

  /**
   * List of urls to other advisors
   */
  advisorUrls: {moc: string | null, wpc: string | null, stc: string | null} = {moc: null, wpc: null, stc: null};

  /**
   * List of toggles to show/hide elements
   */
  toggle = {
    glossary: false,
    investHelp: false,
    equityHelp: false,
    feedinHelp: false,
    compare: false,
    deviceChange: false,
    calculationNeeded: false
  };

  /**
   * HOlds the dimaensoions of the overlay that we need if a recalcultion is needed.
   */
  calculationOverlay: {top: number, bottom: number} = {top: 0, bottom: 0};

  /**
   * extra postfix for some special cases
   */
  headlinePostfix: string = '';

  /**
   * constructor
   * @param portalService
   * @param router
   * @param route
   * @param requestService
   * @param backendService
   * @param elementService
   */
  constructor(protected portalService: PortalService, protected router: Router, protected route: ActivatedRoute,
              protected requestService: PhotovoltaikcheckRequestService, protected backendService: PhotovoltaikcheckBackendService,
              protected elementService: ElementService) {}

  /**
   * @inheritDoc
   */
  ngOnInit(): void {
    this.anfrage = this.requestService.getAnfrage();

    this.previousLink = this.PATH_INPUT_PV;
    if(this.anfrage.interesse === this.INTERESSE_BALKON) {
      this.previousLink = this.PATH_INPUT_BALKON;

      if(this.anfrage.userInput.aufstellort === PhotovoltaikcheckConstants.AUFSTELLORT_FREIFLAECHE) {
        this.previousLink = this.PATH_INPUT_BALKON_FREIFLAECHE;
      }
    }

    // get result from the request object
    const result = Object.keys(this.anfrage.result).length > 0 ? this.anfrage.result : null;

    const systems = result.result?.data?.photovoltaic_systems;
    if(systems?.length === 1) {
      this.headlinePostfix = '.single';
    }

    // set report url
    this.reportUrl = result.report ?? null;

    // preset equity and credit checkbox
    if(this.anfrage.userInput.eigenkapital !== null) {
      this.hasCredit = true;
      this.form.get('credit').setValue(true, {onlySelf: true});
      this.form.get('eigenkapital').setValue(this.anfrage.userInput.eigenkapital, {onlySelf: true});
    }

    // get first configuration from the result
    if(this.anfrage.interesse === PhotovoltaikcheckConstants.PATH_PVANLAGE) {
      this.setSelection(null, result);
    }
    else {
      this.result = this.anfrage.result;
      this.faqTopics = this.anfrage?.result?.result?.ratings?.faqTopics;
      this.advisorUrls = this.anfrage?.result?.result?.ratings?.advisorUrls;
    }

    // listen for changes on the credit input
    this.subscriptions.push(
      this.form.get('credit').valueChanges.subscribe(value => {
        this.hasCredit = value;
        this.toggle.calculationNeeded = true;
        this.toggle.deviceChange = false;
        if(value === true && this.anfrage.userInput.eigenkapital === null) {
          // init values of own equity to 0
          this.anfrage.userInput.eigenkapital = 0;
          this.form.get('eigenkapital').setValue(0, {onlySelf: true});
        }
        else if(value === false && this.anfrage.userInput.eigenkapital !== null) {
          // reset equity and recalculate
          this.form.get('eigenkapital').setValue(null, { onlySelf: true });
        }
        this.reCalculate();

        this.initOverlayBoundings();
      })
    );

    // listen for changes on volleinspeisung toggle
    this.subscriptions.push(
      this.form.get('volleinspeisung').valueChanges.subscribe(value => {
        if(value === true) {
          // change configuration to the one with volleinspeisungvolleinspeisung
          this.setSelection(this.currentConfigurationType + this.OPTIMIERUNG_POSTFIX_VOLLEINSPEISUNG as Optimierung);
        }
        else {
          // change configuration to the one without volleinspeisungvolleinspeisung
          this.setSelection(this.currentConfigurationType.replace(this.OPTIMIERUNG_POSTFIX_VOLLEINSPEISUNG, '') as Optimierung);
        }
      })
    );

    this.hasPortalTeaser = PortalTeaserComponent.hasPortalTeaser();

    // check if internal portal
    this.internalPortal = this.portalService.isInternalPortal();

    // show/hide download module
    const hideReportDownload = this.portalService.getConfigAsBool('embed.newsletter.report.download');
    this.showDownload = !hideReportDownload && this.reportUrl && !this.internalPortal;

    // should the dialog be visible
    this.forceDialog = this.portalService.getConfigAsBool('embed.newsletter.force');

    // init target element
    this.initTargetElement();

    // setup dialog data
    this.initDialogData();
  }

  /**
   * @inheritdoc
   */
  ngAfterViewInit() {
    this.initOverlayBoundings();

    // scroll to top
    this.elementService.scrollToElement(this.top.nativeElement, -80);

    // update height for the compare container
    setTimeout(() => this.updateHeights());
  }

  /**
   * calculate the position of the container.
   */
  @HostListener('window:resize', ['$event'])
  initOverlayBoundings(): void {
    if(this.devices && this.invest) {
      setTimeout(() => {
        const wrapper =  document.querySelector('.step-content-wrapper') as HTMLElement;
        this.calculationOverlay.top = this.devices.nativeElement.offsetHeight + this.devices.nativeElement.offsetTop;
        this.calculationOverlay.bottom = wrapper.offsetHeight - this.invest.nativeElement.offsetTop -
          this.invest.nativeElement.offsetHeight - 60;
      }, 500);
    }
  }

  /**
   * Set the current configuration that the user sees.
   * @param optimierung
   * @param newResult
   */
  setSelection(optimierung: Optimierung = null, newResult?: Result): void {
    // use the old result if we have no new
    if(!newResult) {
      newResult = this.result;
    }

    // fake loading animation
    if(optimierung) {
      this.loading = true;
      setTimeout(() => this.loading = false, 200);
    }

    // check if ther is a individual configuration set
    this.hasIndividualConfiguration = this.anfrage.userInput.eigennutzung_flaeche > 0;

    // select the configuration
    const systems = newResult.result?.data?.photovoltaic_systems;
    if(systems?.length > 0) {
      // check if we have a feed-in-configuration
      this.hasFeedinConfiguration = !!systems.find(configuration => configuration.optimierung === this.OPTIMIERUNG_VOLLEINSPEISUNG);

      // get all own use configurations that are available
      const ownUseConfigurationsAvailable = systems.map(
        system => system.optimierung
      ).filter(
        optimierung => optimierung !== this.OPTIMIERUNG_VOLLEINSPEISUNG
      );

      // if first init, use the available systems and remove the big configurations
      if(this.ownUseConfigurations.length === 0) {
        this.ownUseConfigurations = [this.OPTIMIERUNG_UNABHAENGIG, this.OPTIMIERUNG_WIRTSCHAFTLICH];
      }
      // filter to have only available configurations
      this.ownUseConfigurations = this.ownUseConfigurations.filter(value => ownUseConfigurationsAvailable.includes(value));

      // check if we have some new available
      [this.OPTIMIERUNG_UNABHAENGIG, this.OPTIMIERUNG_WIRTSCHAFTLICH].forEach(ownUseConfig => {
        if(!this.ownUseConfigurations.find(config => config.startsWith(ownUseConfig)) &&
          ownUseConfigurationsAvailable.includes(ownUseConfig)) {
          // config is missing
          if (ownUseConfig === this.OPTIMIERUNG_UNABHAENGIG) {
            this.ownUseConfigurations.unshift(ownUseConfig);
          }
          else {
            this.ownUseConfigurations.push(ownUseConfig);
          }
        }
      });

      if([null, this.OPTIMIERUNG_INDIVIDUELL].indexOf(optimierung) === -1) {
        // use the selected optimization
        this.configuration = systems.find(configuration => configuration.optimierung === optimierung);
        this.currentConfigurationType = optimierung;
      }
      else {
        // check if we have a preset from an old value
        let presetType = this.ownUseConfigurations[0] ?? null;
        if(this.anfrage.configurationSelected && systems.find(
          configuration => configuration.optimierung === this.anfrage.configurationSelected)
        ) {
          presetType = this.anfrage.configurationSelected;
        }

        // default should be this.OPTIMIERUNG_UNABHAENGIG, if not available, use the first in the list
        this.configuration = systems.find(
          configuration => configuration.optimierung === presetType) ?? newResult.result.data.photovoltaic_systems[0];
        this.currentConfigurationType = optimierung ?? this.configuration.optimierung;
      }

      // update placeholder and ratings
      this.placeholder = newResult.result.placeholder[this.currentConfigurationType];
      this.ratings = newResult.result.ratings[this.currentConfigurationType];
      this.faqTopics = Object.values(newResult.result.ratings.faqTopics) ?? [];
      this.advisorUrls = newResult.result.ratings.advisorUrls;

      // show toggle for volleinspeisung if we have such configuration or such configuration exists.
      this.hasVolleinspeisung = this.currentConfigurationType.endsWith(this.OPTIMIERUNG_POSTFIX_VOLLEINSPEISUNG) ||
        !!systems.find(
          configuration => configuration.optimierung === this.currentConfigurationType + this.OPTIMIERUNG_POSTFIX_VOLLEINSPEISUNG);

      // reset toggle for volleinspiesung, if current config is not with volleinspeisung
      if(this.hasVolleinspeisung && this.currentConfigurationType.endsWith(this.OPTIMIERUNG_POSTFIX_VOLLEINSPEISUNG) === false) {
        this.form.get('volleinspeisung').setValue(false, { emitEvent: false });

        // update list of available own use configurations to remember the preset
        this.ownUseConfigurations = this.ownUseConfigurations.map(item => {
          return (item === this.currentConfigurationType + this.OPTIMIERUNG_POSTFIX_VOLLEINSPEISUNG ?
            this.currentConfigurationType : item) as Optimierung;
        });
      }
      else if (this.hasVolleinspeisung) {
        this.form.get('volleinspeisung').setValue(true, { emitEvent: false });

        // update list of available own use configurations to remember the preset
        this.ownUseConfigurations = this.ownUseConfigurations.map(item => {
          return (this.currentConfigurationType.startsWith(item) && item !== this.currentConfigurationType ?
            item + this.OPTIMIERUNG_POSTFIX_VOLLEINSPEISUNG : item) as Optimierung;
        });
      }

      // reset slider values
      this.sliderMin = 0;
      this.sliderMax = Math.max(0, this.configuration.finanzierung.investitionskosten_gesamt - PhotovoltaikcheckConstants.OWN_EQUITY_MIN -
        (this.configuration.finanzierung.foerderung_zuschuss?.summe ?? 0));
      if(this.sliderMax < this.anfrage.userInput.eigenkapital) {
        this.anfrage.userInput.eigenkapital = this.sliderMax;
        this.form.get('eigenkapital').setValue(this.anfrage.userInput.eigenkapital, { emitEvent: false });
      }

      // save selection on request object
      if(this.anfrage.configurationSelected !== this.currentConfigurationType) {
        this.anfrage.configurationSelected = this.currentConfigurationType;
        this.requestService.setAnfrage(this.anfrage, true);
      }

      this.result = newResult;

      // update the configurations for the compare view
      this.compareConfigurations = [...this.ownUseConfigurations];
      if(this.hasFeedinConfiguration) {
        this.compareConfigurations.push(this.OPTIMIERUNG_VOLLEINSPEISUNG);
      }
      if(this.hasIndividualConfiguration) {
        this.compareConfigurations.push(this.OPTIMIERUNG_INDIVIDUELL);
      }

      this.initOverlayBoundings();
    }
  }

  /**
   * Recalculate the system, based on the given input for credit and equity.
   */
  reCalculate(individually: boolean = false): void {
    this.anfrage.userInput.eigenkapital = this.form.get('eigenkapital').value;

    this.requestService.setAnfrage(this.anfrage);

    this.loading = true;
    this.toggle.calculationNeeded = false;
    this.toggle.deviceChange = false;
    this.backendService.getRequestId().subscribe(requestId => {
      this.backendService.result(
        this.anfrage,
        requestId,
        individually
      ).subscribe((result: Result) => {
        // check if the system has changed significant (configuration no longer there or area size changed)
        let significantChange = false;

        // show change hint, if credit is activated and the change was not made individually.
        if(this.hasCredit && !individually && this.currentConfigurationType !== this.OPTIMIERUNG_VOLLEINSPEISUNG) {
          const newConfiguration = result.result.data.photovoltaic_systems.find(
            configuration => configuration.optimierung === this.currentConfigurationType
          );
          if (!newConfiguration) {
            // current config is no longer available
            significantChange = true;
          } else if (((newConfiguration.eigennutzung?.flaeche !== this.configuration.eigennutzung?.flaeche) ||
            (newConfiguration.volleinspeisung?.flaeche !== this.configuration.volleinspeisung?.flaeche))) {
            significantChange = true;
          }
        }

        // save data in browser
        this.anfrage.result = result;
        this.requestService.setAnfrage(this.anfrage);

        // set data on component
        this.setSelection(null, result);

        // scroll up if configuration has changed significant
        if (significantChange) {
          this.toggle.deviceChange = true;
          this.elementService.scrollToElement(this.resultScrollTarget.nativeElement);

          // set focus on credit overlay
          setTimeout(() => {
            this.elementService.setFocusOnElement(this.creditOverlayButton);
          });
        }

        this.loading = false;
      });
    });
  }

  /**
   * reset the invest calculation
   */
  resetRecalculation(): void {
    this.toggle.calculationNeeded = false;
    this.toggle.deviceChange = false;

    // get the new value from the slider
    const newEigenkapital = this.form.get('eigenkapital').value;

    // either deactivate the whole block or reset the value
    if(this.anfrage.userInput.eigenkapital === 0) {
      this.hasCredit = false;
      this.form.get('eigenkapital').setValue(0, { emitEvent: false });
    }
    else {
      this.form.get('eigenkapital').setValue(this.anfrage.userInput.eigenkapital, { emitEvent: false });
    }
  }

  /**
   * Eventhandler if the result hast changed
   */
  onResultUpdatePv(): void {
    this.setSelection(null, this.anfrage.result);
  }

  /**
   * Format the slider value, fix to german number format.
   * @param value
   */
  formatSliderLabel(value: number): string {
    const decimalPipe = new DecimalPipe('de');
    return decimalPipe.transform(value, '1.0-0') + ' €';
  }

  /**
   * @inheritdoc
   */
  ngOnDestroy() {
    // unsubscribe from all subscriptions
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  /**
   * create data object that will be sent to the backend with the registration for the dialog
   */
  initDialogData(): void {
    this.requestService.backendService.getRequestId().subscribe(requestId => {
      this.dialogData = {
        requestId,
        bmOptinSource: window.location.href,
        doisource: 'pvc'
      };
    });
  }

  /**
   * Function is called if the users registered for the dialog
   */
  dialogRegistered(result: string): void {
    const anfrage = this.requestService.getAnfrage();
    anfrage.dialogResult = result;

    this.requestService.setAnfrage(anfrage, true);
  }

  /**
   * show/hide glossary overlay
   */
  toggleGlossary(): void {
    this.toggle.glossary = !this.toggle.glossary;

    if(this.toggle.glossary) {
      this.elementService.scrollToElement(this.resultScrollTarget.nativeElement);
    }
  }

  /**
   * (re)calculate the (min-)height of the compare and price flipper
   */
  @HostListener("window:resize", [])
  updateHeights(): void {
    if(!this.frontCardCompare?.nativeElement || !this.backCardCompare?.nativeElement) {
      // steop here, cards are not available
      return;
    }

    // compare
    this.minHeightCompare = this.frontCardCompare.nativeElement.offsetHeight;
    if(this.toggle.compare) {
      this.minHeightCompare = this.backCardCompare.nativeElement.offsetHeight;
    }
  }

  /**
   * flip the compare view
   */
  flipCompare(): void {
    this.toggle.compare = !this.toggle.compare;

    if(this.toggle.compare) {
      this.elementService.scrollToElement(this.devices.nativeElement);
    }
    this.updateHeights();
  }

  /**
   * recalculate the system, based in some changes from inside the graphic.
   * @param adaptions
   */
  recalculateAreas(adaptions: ConfigurationAdaptions): void {
    // calculate new area sizes
    const area = this.anfrage.userInput.flaeche_verfuegbar;
    const areaOwnUse = area * adaptions.ownuse;
    const areaFeedin = area * adaptions.feedin;

    // call backend for new calculation
    this.anfrage.userInput.volleinspeisung_flaeche = areaFeedin;
    this.anfrage.userInput.eigennutzung_flaeche = areaOwnUse;
    this.anfrage.userInput.batteriespeicher_kapazitaet = adaptions.battery;

    this.reCalculate(true);
  }

  /**
   * init the target element
   */
  initTargetElement(): void {
    // add css class to dialog or download module
    if (this.forceDialog) {
      this.idTargetElement = 'lead';
    } else if (this.showDownload) {
      this.idTargetElement = 'download';
    }
  }

}
